var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ws-downfile",on:{"click":function($event){return _vm.downfile()}}},[_vm._t("default",[(_vm.name)?_c('el-tag',[_vm._v(_vm._s(_vm.name))]):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }